require('/var/www/e-motors.fr/releases/217/assets/scripts/vendor.js')